import { getStore } from "../../store/configureStore";
import * as domainConstants from "../../constants/DomainConstants";
import mergeDeep from "../../util/mergeDeep.js";

export default class ProjectPageHelper {

	constructor(context, redirector) {
		this.dispatch = getStore().dispatch;
		this.context = context;
		this.redirector = redirector;
	}

	change(event, data, i) {
		const project = this.context.state.project;
		let field = null;
		let value = null;

		if (data) {
			field = data.name;
			value = data.value;
		} else {
			field = event.target.name;
			value = field === "verdwijnenErInfrastructurenNietInSpakki" ? event.target.checked : event.target.value;
		}

		if (i != null) {
			const replacedFieldTarget = field.replace("" + i, "");
			const oldValue = project.sportinfrastructurenInDeBuurt[i][replacedFieldTarget];

			project.sportinfrastructurenInDeBuurt[i][replacedFieldTarget] = value;
			project.sportinfrastructurenInDeBuurt[i][replacedFieldTarget + "_original"] = oldValue;

			let infraOpDeKaart = project.sportinfrastructurenOpKaart.find(x => x.id === project.sportinfrastructurenInDeBuurt[i].id);

			if (infraOpDeKaart) {
				project.sportinfrastructurenOpKaart.find(x => x.id === project.sportinfrastructurenInDeBuurt[i].id)[replacedFieldTarget] = value;
				project.sportinfrastructurenOpKaart.find(x => x.id === project.sportinfrastructurenInDeBuurt[i].id)[replacedFieldTarget + "_original"] = oldValue;
			}

			//TODO Nog Nodig?
			if (field === "deelVanAanvraag" + i) {
				let infraModalIsOpen = false;
				let infraStatusGewijzigd = this.state.infraStatusGewijzigd;
				if (value == "true" || value === true)
					window.parent.scrollTo(0, 450);

				if (value === "0" || value === 0)
					infraModalIsOpen = true;
				else
					this.context.setState({ hasUnsavedChanges: true });

				if (!infraStatusGewijzigd && this.isStatusGewijzigdVoorMelding(value, oldValue))
					infraStatusGewijzigd = true;

				return this.context.setState({
					infraModalIsOpen: infraModalIsOpen,
					changedInfrastructuur: project.sportinfrastructurenInDeBuurt[i].id,
					project: project,
					infraStatusGewijzigd: infraStatusGewijzigd
				});
			}
		} else {
			project[field] = value;
		}

		return this.context.setState({
			project: project,
			hasUnsavedChanges: true
		});
	}

	isStatusGewijzigdVoorMelding(value, oldValue) {
		return ((oldValue == "0" || oldValue === 0) && (value == "1" || value === 1 || value == "2" || value === 2))
			|| ((oldValue == "1" || oldValue === 1) && (value == "2" || value === 2));
	}

	// --------------------------NIEUWBOUW--------------------------------------------------

	editNieuwbouw(id) {
		this.onEdit(id);
	}

	deleteNieuwbouw(id) {
		return this.context.setState({
			deleteNieuwbouwInfraModalIsOpen: true,
			nieuwbouwToRemoveId: id
		});
	}

	cancelDeleteNieuwbouwInfra() {
		return this.context.setState({
			deleteNieuwbouwInfraModalIsOpen: false
		});
	}

	gotoDeleteNieuwbouwInfra() {
		const sportInfraId = this.context.state.nieuwbouwToRemoveId;
		const project = this.context.state.project;
		const infraindex = project.sportinfrastructurenInDeBuurt.indexOf(project.sportinfrastructurenInDeBuurt.find(x => x.id === sportInfraId));

		project.sportinfrastructurenInDeBuurt.splice(infraindex, 1);

		return this.context.setState({
			deleteNieuwbouwInfraModalIsOpen: false,
			nieuwbouwToRemoveId: null,
			project,
			hasUnsavedChanges: true
		});
	}

	addNieuwbouwInfra() {
		return this.context.setState({
			addNieuwbouwInfraModalIsOpen: true
		});
	}

	cancelAddNieuwbouwInfra() {
		return this.context.setState({
			addNieuwbouwInfraModalIsOpen: false
		});
	}

	gotoAddNieuwbouwInfra() {
		this.goToInfrastructuurDetailPage(`project/${this.context.state.project.dossierId}/add/infraNieuwbouw`);
	}

	closeNieuwbouwModal() {
		this.context.setState({ nieuwbouwModalIsOpen: false });
	}

	// --------------------------NIEUWBOUW--------------------------------------------------
	// --------------------------RENOVATIE--------------------------------------------------

	editRenovatie(id) {
		this.onEdit(id);
	}

	addRenovatieInfra() {
		return this.context.setState({
			addRenovatieInfraModalIsOpen: true
		});
	}

	cancelAddRenovatieInfra() {
		return this.context.setState({
			addRenovatieInfraModalIsOpen: false
		});
	}

	gotoAddRenovatieInfra() {
		this.goToInfrastructuurDetailPage(`project/${this.context.state.project.dossierId}/add/infraRenovatie`);
	}

	goToRenovatieInfrastructuurDetail() {
		this.goToInfrastructuurDetailPage(`project/${this.context.state.project.dossierId}/add/infraRenovatie/${this.context.state.changedInfrastructuur}`);
	}

	cancelRenovatieInfrastructuurDetail() {
		const project = this.context.state.project;
		project.sportinfrastructurenInDeBuurt.find(x => x.id === this.context.state.changedInfrastructuur)["deelVanAanvraag"] = 1;
		return this.context.setState({
			addRenovatieToProjectModalIsOpen: false,
			project: project
		});
	}

	changeRenovatieTable(event, id) {
		const value = event.target.checked;
		const project = mergeDeep({}, this.context.state.project);
		const infra = project.sportinfrastructurenInDeBuurt.filter(i => i.id === id)[0];
		infra.deelVanAanvraag_original = infra.deelVanAanvraag;

		if (value === "true" || value === true) {
			infra.soortWerken = domainConstants.INFRASTRUCTUUR_TYPE.RENOVATIE;
			infra.deelVanAanvraag = "0";

			this.context.setState({
				changedInfrastructuur: infra.id,
				project: project,
				addRenovatieToProjectModalIsOpen: true
			});
		} else {
			infra.deelVanAanvraag = "1";
			infra.soortWerken = null;

			this.context.setState({
				changedInfrastructuur: infra.id,
				project: project,
				hasUnsavedChanges: true
			});
		}
	}

	changeVerdwijnendeInfraTable(event, id) {
		const value = event.target.checked;
		const project = mergeDeep({}, this.context.state.project);
		const infra = project.sportinfrastructurenInDeBuurt.filter(i => i.id === id)[0];

		if (value === "true" || value === true) {
			infra.deelVanAanvraag = "2";

			this.context.setState({
				project: project,
				hasUnsavedChanges: true
			});
		} else {
			infra.deelVanAanvraag = "1";

			this.context.setState({
				project: project,
				hasUnsavedChanges: true
			});
		}

		this.context.props.projectSaved(project, false);
	}

	// --------------------------RENOVATIE--------------------------------------------------

	onEdit(id) {
		this.context.setState({
			changedInfrastructuur: id
		}, () => this.goToInfrastructuurDetailPage(`project/${this.context.state.project.dossierId}/edit/infra/${this.context.state.changedInfrastructuur}`));
	}

	goToInfrastructuurDetailPage(url) {
		const props = this.context.props;
		const state = this.context.state;

		props.projectLoaded(state.project, null, !state.hasUnsavedChanges);
		this.context.setState({ hasUnsavedChanges: false, shouldKeepProject: true }, () => {
			this.redirector.goTo(url);
		});
	}
}